import React, { Suspense, useState } from 'react';
import PropTypes from 'prop-types';
import { api, clearResourceCache, historyFrouceUpdate, useResource } from 'app';
import date from 'helpers/utils/date';
import { Container } from 'components/Page';
import CampaignForm from 'routes/createCampaign/components/CampaignForm';
import SuccessModal from './SuccessModal';

function EditCampaignInfoForm({ campaignId }) {
  const [status, setStatus] = useState('none');

  clearResourceCache('campaignFilter', 'collection');

  const campaign = useResource('campaign', 'single', `/advertising-campaigns/${campaignId}`);

  const campaignData = campaign.body.data;

  let initialValues = {
    ...campaignData,
    description_sms: campaignData.channel === 'sms' ? campaignData.description : '',
    send_date: date(campaignData.send_date).formatForApi()
  };

  if (campaignData.channel === 'email') {
    initialValues = {
      ...initialValues,
      emailUtm: campaignData.utm
    };
  } else if (campaignData.channel === 'sms') {
    initialValues = {
      ...initialValues,
      smsUtm: campaignData.utm
    };
  }

  const handleClose = () => {
    setStatus('none');
    historyFrouceUpdate.push(`/campaigns/${campaignId}/info`);
  };

  const handleSubmit = data => {
    return api.put(`/advertising-campaigns/${campaignData.id}`, data).then(response => {
      clearResourceCache('campaign', 'collection');
      clearResourceCache('campaign', 'single');
      setStatus('submitSucceeded');
    });
  };

  return [
    <CampaignForm
      key="updateCampaign"
      initialValues={initialValues}
      name="updateCampaign"
      onSubmit={handleSubmit}
      submitButtonText="ذخیره تغییرات کمپین"
    />,
    <SuccessModal key="SuccessModal" show={status === 'submitSucceeded'} onHide={handleClose} />
  ];
}

function EditCampaignInfo({ campaignId }) {
  return (
    <Suspense fallback={'...'}>
      <Container size="small">
        <EditCampaignInfoForm campaignId={campaignId} />
      </Container>
    </Suspense>
  );
}

EditCampaignInfo.propTypes = {
  campaignId: PropTypes.number.isRequired
};

export default EditCampaignInfo;
